import ADITYA from "../assets/team/Aditya.jpg";
import ARUNDATHI from "../assets/team/Arundathi.jpeg";
import ASWIN from "../assets/team/Aswin.jpeg";
import POOJA from "../assets/team/Pooja.jpeg";
import SANIKA from "../assets/team/SANIKAU.jpeg";
import SANKET from "../assets/team/Sanket.jpeg";
import SRINATH from "../assets/team/Srinath.jpeg";
import SRISHTI from "../assets/team/Srishti .jpeg";
import SUMANTA from "../assets/team/Sumanta.jpg";
import TWINKLE from "../assets/team/Twinkle.jpeg";
import VISHNU from "../assets/team/Vishnu.jpeg";
import Vinod_PPSpecs from "../assets/team/Vinod_PPSpecs.JPG";
import ANISHLAZAR from "../assets/team/Anishlazar.PNG";
import BETSYKJ from "../assets/team/Betsykj.PNG";
import GOVINDPORWAL from "../assets/team/GovindPorwal.PNG";
import PREETIJAIN from "../assets/team/PreetiJain.PNG";
import SHARADGUPTA from "../assets/team/SharadGupta.PNG";
import SHREEDHALA from "../assets/team/Shreedhala.PNG";
import SUNILSEKHAR from "../assets/team/Sunilsekhar.PNG";
import VYSAKHAB from "../assets/team/Vysakhab.PNG";
import YOGITASONI from "../assets/team/yogitasoni.PNG";
import JYOTSNA from "../assets/team/Jyotsna.png";
import ANURADHA from "../assets/team/ANURADHA.jpg";
import PAWAN from "../assets/team/PAWANKUMAR.jpg";

export const groupMembers = [
    {
        "id": 1,
        "name": "Sanket Bhumare",
        "designation": "PhD SRF",
        "researchArea": "Utilization of CO2 and CH4 under mild reaction conditions",
        "conferences": [
            "9th Green and Sustainable Chemistry Conference by elsevier",
            "Indo-French Seminar on Catalysis for Sustainability (CIFES), IISER TVM",
            "NCL RF conference"
        ],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":SANKET
    },
    {
        "id":2,
        "name":"Ms. Jyotsna P. Bajpai",
        "designation":"Senior Research Fellow",
        "researchArea":"Catalyst development for CO2 hydrogenation to value-added products",
        "conferences":[],
        "awards":[],
        "publications":[
            {
            "title":"Unravelling the Cu-Co nanoparticle synergy over Ceria-Zirconia support toward efficient reverse water gas shift (RWGS) conversion under H2 lean conditions",
            "year":2025,
            "journal":"Chemical Engineering Journal"
        },{
            "title":"Exploring the electronic modulation in controlling the activity and selectivity of Ni-Au-In based catalyst in atmospheric pressure CO2 hydrogenation",
            "year":2025,
            "journal":"Chemical Engineering Journal"
        }
    ],
        "patents":[],
        "imageURL":JYOTSNA
    },
    {
        "id": 3,
        "name": "Twinkle Gorai",
        "designation": "DST-Inspire SRF",
        "researchArea": "CO2 fixation into cyclic organic carbonates (COCs) and its application in aqueous zinc ion battery",
        "awards": [
            {
                "title": "CACEE 2024 Best Poster Award",
                "conference": "TIFR Mumbai"
            }
        ],
        "achievements": [
            "AcSIR-RMIT Dual Ph.D Program under Dr. Suresh Bhargava, Dr. Selvekannan Periasamy, and Dr. Paramita Koley"
        ],
        "publications": [
            {
                "title": "Publication 1",
                "doi": "10.1016/j.cej.2025.163159",
                "url": "https://doi.org/10.1016/j.cej.2025.163159"
            },
            {
                "title": "Publication 2",
                "doi": "10.1002/chem.202500873",
                "url": "https://doi.org/10.1002/chem.202500873"
            }
        ],
        "patents": [],
        "imageURL":TWINKLE
    },
    {
        "id": 4,
        "name": "Pooja Nehra",
        "designation": "PhD SRF",
        "researchArea": "Developing efficient catalytic materials for hydrogenation of CO2 to value added products & biomass conversion",
        "publications": [
            {
                "title": "Selective Hydrogenation of Furfural to Furfuryl Alcohol over Pd Supported on Ternary Oxide in Aqueous Medium Under Mild Conditions",
                "year": 2025,
                "journal": "ChemCatChem"
            }
        ],
        "awards": [
            {
                "title": "Best poster award in catalysis & inorganic chemistry division",
                "conference": "NCL-RF Agnimitra Memorial Poster Award, National Science Day 2024 at CSIR-NCL, Pune"
            },
            {
                "title": "Best poster award",
                "conference": "International Conference on Carbon Capture & Utilisation 2024 at JNCASR, India"
            }
        ],
        "conferences": [
            "Indo-French seminar on Catalysis for sustainability at IISER TVM"
        ],
        "patents": [],
        "imageURL":POOJA
    },
    {
        "id": 5,
        "name": "Srishti Kesarwani",
        "designation": "PhD SRF",
        "researchArea": "Tailored Nanocatalysts for Sustainable Biomass and CH4 Valorization",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":SRISHTI
    },
    {
        "id": 6,
        "name": "Arundhathi K V",
        "designation": "PhD SRF",
        "researchArea": "Developing Novel Catalysts for Methane and Nitrogen Activation",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":ARUNDATHI
    },
    {
        "id": 7,
        "name": "Sanika U",
        "designation": "PhD JRF",
        "researchArea": "Design and development of novel catalysts for CO2 reduction. CO2 fixation through organic drug intermediates synthesis",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":SANIKA
    },
    {
        "id": 8,
        "name": "Srinath Das",
        "designation": "Project Associate-I",
        "researchArea": "Employing operando NAP-XPS and DRIFTS to elucidate structure-composition-function correlations in catalytic reactions",
        "patents": [
            {
                "title": "A biopolymer-based metal-organic framework composite and method of fabrication thereof",
                "inventors": "Choudhary Munmun, De Asmita, Das Srinath, Mishra Sumit",
                "status": "Published",
                "publishedDate": "2024-09-20",
                "filedDate": "2024-07-12",
                "applicationNo": "202431053454"
            }
        ],
        "conferences": [],
        "awards": [],
        "publications": [],
        "imageURL":SRINATH
    },
    {
        "id": 9,
        "name": "Sumanta Giri",
        "designation": "Project Associate-I",
        "researchArea": "Thermal and Electro-Catalysis of CO2 and N2 reduction",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":SUMANTA
    },
    {
        "id": 10,
        "name": "Aditya A Nile",
        "designation": "Project Associate 1",
        "researchArea": "Designing and optimizing CO₂-to-methanol processes via catalytic hydrogenation with emphasis on reactor operation and process integration within the CCUS framework",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":ADITYA
    },
    {
        "id": 11,
        "name": "Vishnu vyas",
        "designation": "Project Associate-1",
        "researchArea": "Finding sustainable solutions for carbon capture, utilization and storage through designing efficient catalytic materials",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":VISHNU
    },
    {
        "id": 12,
        "name": "Aswin Sreenivas B K",
        "designation": "Project Associate 1",
        "researchArea": "Experimental descriptors by unravelling oxygen and nitrogen electrochemistry through surface spectroscopy techniques",
        "conferences": [],
        "awards": [],
        "publications": [],
        "patents": [],
        "imageURL":ASWIN
    }
];

export const groupLeader = [
    {
        id:"grphead_001",
        name:"Dr. C. P. Vinod FRSC",
        designation:"Chief Scientist & Prof (AcSIR)",
        mail:"cp.vinod.ncl@csir.res.in",
        description:"C P Vinod completed his PhD in 2001 under the guidance of Prof. CNR Rao FRS in the field of Surface Science and Catalysis from Jawaharlal Nehru Centre For Advanced Scientific Research, Bangalore. Subsequently, he was a postdoctoral fellow at several prestigious European universities like, the Technical University of Eindhoven, Technical University of Denmark and Cardiff University (UK). In 2010, he joined as Senior Scientist at CSIR-National Chemical Laboratory, Pune where he currently holds the position of Chief Scientist. He is also a Professor at the Academy of Scientific and Innovative Research (AcSIR), Ghaziabad, India, an institute of national importance.",
        researchFocus:"We work in the field of surface science  with special emphasize on understanding nanoscale catalysis phenomena. Designing new functional nanomaterials for catalytic application requires a molecular level understanding on the bond breaking and making process on the catalyst surface. We create flat model surfaces or structured nanoparticles and employ surface sensitive technique like X-ray Photoelectron Spectroscopy (XPS) and high resolution microscopes like STM/AFM and HRTEM to arrive at structure vs activity correlations. Such studies has resulted in novel catalysts for environmentally important reactions like CO oxidation, CO2 hydrogentaion and methane partial oxidation. We also look at catalyst development for fixing CO2 more efficiently for producing platform organic molecules",
        imageURL: Vinod_PPSpecs
    }
];

export const phdAlumini = [
    {
        id:"phdalumini_001",
        name:"Dr. Sunil Shekhar A C",
        tenure:"2011 - 2016",
        thesisTitle:"Metal oxide supported nobel metal catalyst: Powders, Thin films and Nanostructures",
        currentPosition:"Assistant Professor, Department of Chemistry, Union Christian College, Aluva-683102",
        email:["sunilsekhar@uccollege.edu.in","sunilsekharac@gmail.com"],
        imageURL: SUNILSEKHAR
    },{
        id:"phdalumini_002",
        name:"Dr. S. Sreedhala",
        tenure:"2011 - 2016",
        thesisTitle:"Studies on structured model nanoparticle surfaces for active site elucidation in heterogenous catalysis",
        currentPosition:"N/A",
        email:[
            "srdhls4@gmail.com"
        ],
        imageURL:SHREEDHALA
    },{
        id:"phdalumini_003",
        name:"Dr. Vysakh A B",
        tenure:"2011 - 2017",
        thesisTitle:"Reactivity of Strained Bimetallics Systems: A Case Study of Au-Ni Nanoparticles",
        currentPosition:"Assistant Manager (Research) at Indian Oil R&D Center",
        email:"vysakhab@gmail.com",
        imageURL:VYSAKHAB
    },{
        id:"phdalumini_004",
        name:"Dr. Yogita Soni",
        tenure:"2013 - 2019",
        thesisTitle:"New formulation for nobal metal (Au, Pd) supported metal oxides and their catalytic applications",
        currentPosition:"Post doctoral researcher at Tufts University, Massachusetts, USA",
        email:"yogitaksoni@gmail.com",
        imageURL:YOGITASONI
    },{
        id:"phdalumini_005",
        name:"Dr. Anish Lazar",
        tenure: "2014 - 2018",
        thesisTitle:"Metal-organofunctionalized SBA-15 catalysts for fine chemical synthesis",
        currentPosition:"Post-doctoral Fellow at IS2M, Mulhouse, France",
        email:"anishlaz@gmail.com",
        imageURL:ANISHLAZAR
    },{
        id:"phdalumini_006",
        name:"Dr. Sharad Gupta",
        tenure:"2014 - 2020",
        thesisTitle:"Exploring Metal Oxide Nanostructures for CO2 Hydrogenation",
        currentPosition:"Post-doctoral Fellow at UCEiV Universite Du Littoral Cote D'Opale  (ULCO) Dunkerque, France",
        email:"sharadgupta195@gmail.com",
        imageURL:SHARADGUPTA
    },{
        id:"phdalumini_007",
        name:"Dr. Preeti Jain",
        tenure:"2014 - 2020",
        thesisTitle:"Investigation on Cobalt-based catalysts for Energy Applications",
        currentPosition:"Post-doctoral Fellow, CEBC, Kanas State University, Lawrence, KS, USA",
        email:"preetijanney@gmail.com",
        imageURL:PREETIJAIN
    },{
        id:"phdalumini_008",
        name:"Dr. Betsy K J",
        tenure:"2018 - 2022",
        thesisTitle:"Exploring the Chemical Modifications in Periodic Mesoporous Silica Materials for Heterogenous Catalytic Applications",
        currentPosition:"Department of Chemistry, Denmark Technical University (DTU), Denmark",
        email:"betzeekj@gmail.com",
        imageURL:BETSYKJ
    },{
        id:"phdalumini_009",
        name:"Dr. Govind Porwal",
        tenure:"2016 - 2020",
        thesisTitle:"Insights on the synthesis of fine chemicals and its upscaling on heterogenous catalysts",
        currentPosition:"Research Manager in Rashtriya Chemicals & Fertilizers Limited",
        email:"govind2708@gmail.com",
        imageURL:GOVINDPORWAL
    },{
        id:"phdalumini_010",
        name:"Dr. Anuradha V Jagtap",
        tenure:"2018 - 2024",
        thesisTitle:"Developing new catalytic material for C1 molecule activation",
        // currentPosition:"N/A",
        email:"avjagtap30@gmail.com",
        imageURL:ANURADHA
    },{
        id:"phdalumini_011",
        name:"Dr. Pawan Kumar",
        tenure:"2020 - 2024",
        thesisTitle:"Catalyst designing for C-H activation",
        currentPosition:"CNRS Postdoctoral Researcher, Univ of Lille, France",
        email:"pawan4singh15@gmail.com",
        imageURL:PAWAN
    }
];